import { useState, useEffect } from 'react';

export const useLocalStorage = <T>(key: string, defaultValue: T) => {
  // Helper functions
  const getSavedState = (key: string, defaultValue: T): T => {
    try {
      const saved = localStorage.getItem(key);
      return saved ? JSON.parse(saved) : defaultValue;
    } catch {
      return defaultValue;
    }
  };

  const saveState = (key: string, value: T): void => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Ignore localStorage errors
    }
  };

  // Initialize state with saved value or default
  const [state, setState] = useState<T>(() => getSavedState(key, defaultValue));

  // Save to localStorage whenever state changes
  useEffect(() => {
    saveState(key, state);
  }, [key, state]);

  return [state, setState] as const;
}; 